export { default } from './Loading'



// WEBPACK FOOTER //
// ./src/App/pages/Loading/index.js